import client from '../../client';
import {
  GET_SUB_DATA,
  GET_SUB_DATA_SUCCESS,
  GET_SUB_DATA_FAIL,
  GET_LAST_SUB_DATA,
  GET_LAST_SUB_DATA_SUCCESS,
  GET_LAST_SUB_DATA_FAIL,
  GET_AGG_SUB_DATA,
  GET_AGG_SUB_DATA_SUCCESS,
  GET_AGG_SUB_DATA_FAIL
} from '../constants/sub';

export const getSubData = (params, graphId) => dispatch => {
  dispatch({
    type: GET_SUB_DATA,
    graphId
  });

  client
    .get('/subs', { params })
    .then(res => {
      dispatch({
        type: GET_SUB_DATA_SUCCESS,
        data: res.data,
        graphId
      });
    })
    .catch(error => {
      dispatch({
        type: GET_SUB_DATA_FAIL,
        error,
        graphId
      })
    });
}

export const fetchLastSubData = (params, graphId) => dispatch => {
  dispatch({
    type: GET_LAST_SUB_DATA,
    graphId
  });
  client
    .get('/subs', { params: {
      ...params,
      last: 1
    } })
    .then(res => {
      dispatch({
        type: GET_LAST_SUB_DATA_SUCCESS,
        lastData: res.data,
        graphId
      });
    })
    .catch(error => {
      dispatch({
        type: GET_LAST_SUB_DATA_FAIL,
        error,
        graphId
      })
    });
}

export const fetchAggSubData = () => dispatch => {
  dispatch({
    type: GET_AGG_SUB_DATA
  });
  client
    .get('/subs/agg')
    .then(res => {
      dispatch({
        type: GET_AGG_SUB_DATA_SUCCESS,
        data: res.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_AGG_SUB_DATA_FAIL,
        error
      })
    });

}



// WEBPACK FOOTER //
// ./src/redux/actions/sub.js